import { createVuetify } from "vuetify";
// import "vuetify/styles";
import * as components from "vuetify/components";
import * as labsComponents from "vuetify/labs/components";
// import Ripple from "vuetify/lib/directives/ripple";

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components: {
      ...components,
      ...labsComponents,
    },
    theme: {
      defaultTheme: "light",
      treeShake: true,
      themes: {
        light: {
          dark: false,
          colors: {
            background: "#F9F9F9",
            success: "#1BBC48",
            primary: "#af2a2c",
            secondary: "#F8F8F8",
            anchor: "#8c9eff",
            info: "#000080",
            error: "#af2a2c",
          },
        },
      },
    },
    // directives: {
    // Ripple,
    // },
  });
  nuxtApp.vueApp.use(vuetify);
});
